import { fontWeightClassName, fontWeights } from '@va/ui/design-system';
import classNames from 'classnames';
import { PropsWithChildren, Ref, forwardRef } from 'react';
import { getTypographyClassNames } from './helpers';
import { HeadingProps, TypographyProps, TypographyVariants } from './types';

export const Heading5 = forwardRef(
  <T extends keyof TypographyVariants>(
    {
      weight = fontWeights.normal,
      colorClassName = 'text-text-dark',
      className,
      children,
      variant,
      variantSize,
    }: PropsWithChildren<HeadingProps & TypographyProps<T>>,
    ref: Ref<HTMLHeadingElement>,
  ) => {
    const typographyClasses = getTypographyClassNames({ variant, variantSize });

    const classes = classNames(
      'font-primary',
      { 'text-21 leading-30 -tracking-0021': !typographyClasses, [typographyClasses]: !!typographyClasses },
      fontWeightClassName(weight),
      colorClassName,
      className,
    );

    return (
      <h5 ref={ref} className={classes}>
        {children}
      </h5>
    );
  },
);
